import TextFieldComponent from '../../TextFieldComponent';
import { useState } from 'react';
import { FilterAlt, Search } from '@mui/icons-material';
import ButtonComponent from '../../ButtonComponent';
import { t } from 'i18next';

interface MainFilterProps {
  onChangeText: (text: string) => void;
  onOpenFilter?: () => void;
  onSubmit?: () => void;
  searchValue?: string;
}

const MainFilter = ({
  onChangeText,
  onSubmit,
  onOpenFilter,
  searchValue
}: MainFilterProps) => {
  const [value, setValue] = useState<string>('');

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (onSubmit) onSubmit();
        }}
      >
        <TextFieldComponent
          fullWidth
          iconStart={<Search color={'primary'} />}
          placeholder={t('tableComponent.searchHere')}
          rightComponent={
            <>
              <ButtonComponent
                type="submit"
                tooltipMessage={t('tableComponent.search')}
                sx={{
                  boxShadow: 0,
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: onOpenFilter && 0,
                  borderTopRightRadius: onOpenFilter && 0,
                  height: '100%',
                }}
              >
                <Search sx={{ fontSize: 30 }} />
              </ButtonComponent>
              {onOpenFilter && (
                <ButtonComponent
                  color={'warning'}
                  onClick={onOpenFilter}
                  tooltipMessage={'Filtrar'}
                  sx={{
                    boxShadow: 0,
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    height: '100%',
                  }}
                >
                  <FilterAlt />
                </ButtonComponent>
              )}
            </>
          }
          value={searchValue || ''}
          onChangeText={onChangeText}
        />
      </form>
    </>
  );
};

export default MainFilter;
